<script setup>

import HeaderComponent from "@/components/Header/HeaderComponent.vue";



</script>

<template>
  <HeaderComponent/>
  <main>
    <router-view/>
  </main>

</template>

<style scoped>

</style>
